<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               top="20px"
               @close="handleClose"
               @open="handleOpen"
               :width="dialogWidth">
      <div style="display:flex">
        <div class="dialog-wrap">
          <div class="dialog-item">

            <div class="title">
              <div class="blue"></div>
              <span>商品信息</span>
            </div>

            <div class="goodsMess"
                 style="marginTop:16px">
              <div class="messItem">
                <p class="itemLeft">ID</p>
                <p class="itemRight">{{content.id}}</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">类型</p>
                <div class="itemRight">
                  <p v-if="content.order_note_info_obj">
                    <span v-if="content.order_note_info_obj.note_ref_type==1">资料</span>
                    <span v-if="content.order_note_info_obj.note_ref_type==2">课程</span>
                    <span v-if="content.order_note_info_obj.note_ref_type==3">答疑卡</span>
                    <span v-if="content.order_note_info_obj.note_ref_type==4">1对1</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">名称</p>
                <p class="itemRight">{{content.goods_name}}</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">规格</p>
                <div class="itemRight">

                  <div v-if="content.sku">
                    <span v-for="(item,index) in content.sku.properties"
                          :key="index">
                      {{ item.val }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="goodsMess"
                 style=" border-bottom: 1px solid rgb(215, 213, 213)">
              <div class="messItem">
                <p class="itemLeft">原价</p>
                <p class="itemRight"> {{content.total_amount}}元</p>
              </div>
            </div>
          </div>
          <div class="dialog-item"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>订单信息</span>
            </div>
            <div class="goodsMess"
                 style="marginTop:16px">
              <div class="messItem">
                <p class="itemLeft">订单号</p>
                <p class="itemRight">{{content.order_no}}</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">订单状态</p>
                <p class="itemRight">
                  <el-tag v-if="content.status==0"
                          type="warning"> 待支付</el-tag>
                  <el-tag v-if="content.status==1"
                          type="success"> 已支付</el-tag>
                  <el-tag v-if="content.status==2"
                          type="warning"> 待发货</el-tag>
                  <el-tag v-if="content.status==3"> 待收货</el-tag>
                  <el-tag v-if="content.status==4"
                          type="success"> 已完成</el-tag>
                  <el-tag v-if="content.status==5"> 已取消</el-tag>
                  <el-tag v-if="content.status==6"
                          type="warning"> 待辅导</el-tag>
                  <el-tag v-if="content.status==7"> 辅导中</el-tag>
                  <el-tag v-if="content.status==8"> 待核销</el-tag>
                  <el-tag v-if="content.status==9"
                          type="info"> 核销中</el-tag>

                </p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">订单金额</p>
                <p class="itemRight">{{content.price||'0'}}元</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">优惠金额</p>
                <p class="itemRight"> {{ content.user_coupon_amount || "0" }}元</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">支付金额</p>
                <p class="itemRight"> {{content.pay_amount||'0'}}元</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">支付方式</p>
                <p class="itemRight"> <span v-if="content.pay_type==0">-</span>
                  <span v-else-if="content.pay_type==1">支付宝</span>
                  <span v-else-if="content.pay_type==2">微信</span>
                  <span v-else-if="content.pay_type==3">系统</span>
                  <span v-else-if="content.pay_type==4">
                    <span v-if="content.hb_fq_seller_percent==100">
                      花呗分期(免{{content.hb_fq_num}}期)
                    </span>
                    <span v-else>花呗分期</span>
                  </span>
                  <span v-else-if="content.pay_type==5">研币</span>
                </p>
              </div>
            </div>

            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">支付状态</p>
                <p class="itemRight">
                  <el-tag v-if="content.pay_status==0"
                          type="warning"> 未支付</el-tag>
                  <el-tag v-if="content.pay_status==1"
                          type="success"> 已支付</el-tag>
                  <el-tag v-if="content.pay_status==2"
                          type="info"> 已取消</el-tag>
                </p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">下单时间</p>
                <p class="itemRight">{{
                $moment(content.create_time).format("YYYY-MM-DD hh:mm:ss")
              }}</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">支付时间</p>
                <p class="itemRight">
                  <span v-if="content.pay_time"> {{
                $moment(content.pay_time).format("YYYY-MM-DD hh:mm:ss")
              }}</span>
                  <span v-else>-</span>
                </p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">完成时间</p>
                <p class="itemRight">{{
                $moment(content.note_finish_time ).format("YYYY-MM-DD hh:mm:ss")
              }}</p>
              </div>
            </div>
            <div class="goodsMess">
              <div class="messItem">
                <p class="itemLeft">商户交易号</p>
                <p class="itemRight">{{ content.out_trade_no || "--" }}</p>
              </div>
            </div>
            <div class="goodsMess"
                 style=" border-bottom: 1px solid rgb(215, 213, 213)">
              <div class="messItem">
                <p class="itemLeft">支付订单号</p>
                <p class="itemRight">{{ content.pay_trade_no || "--" }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="dialog-wrap"
             style="marginLeft:40px">
          <div class="dialog-item"
               v-if="title=='查看详情'">
            <div class="title">
              <div class="blue"></div>
              <span>备注信息</span>
            </div>
          </div>
          <el-form ref="searchForm"
                   style="marginTop:25px"
                   :inline="true"
                   :model="form"
                   label-width="70px"
                   v-if="title=='查看详情'">
            <el-form-item label="用户备注"
                          prop="order_no">
              <el-input @input="Update('buyer_remark')"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入买家备注"
                        v-model="content.buyer_remark">
              </el-input>
            </el-form-item>
            <el-form-item label="商品备注"
                          prop="order_no">
              <el-input @input="Update('seller_remark')"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入卖家备注"
                        v-model="content.seller_remark">
              </el-input>
            </el-form-item>
            <el-form-item label="服务备注"
                          v-if="content.onetoone_obj"
                          prop="order_no">
              <el-input @input="statusUpdate('course_before_remark')"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入服务备注"
                        v-model="content.onetoone_obj.course_before_remark">
              </el-input>
            </el-form-item>

          </el-form>
          <div class="dialog-item"
               style="marginTop:20px"
               v-if="title=='查看详情'">
            <div class="title">
              <div class="blue"></div>
              <span>发货信息</span>
            </div>
          </div>
          <el-form ref="searchForm"
                   style="marginTop:20px"
                   v-if="title=='查看详情'"
                   :inline="true"
                   :model="form"
                   label-width="70px">
            <el-form-item label="选择快递"
                          prop="order_no">
              <el-select v-model="form.express_code"
                         placeholder="请选择院快递公司"
                         style="width: 100%;">
                <el-option v-for="item in expressList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="快递单号"
                          prop="order_no">
              <el-input v-model="content.express_no"
                        placeholder="这里是单号"
                        clearable
                        style="width:200px;"></el-input>
            </el-form-item>
            <div style="marginTop:10px">物流信息 ：<span v-if="expressInfo==null">暂无数据</span></div>

            <div class="value">
              <div class="info-list"
                   v-if="expressInfo">
                <div class="info-item"
                     v-for="(item, index) of expressInfo.list"
                     :key="index">
                  <div class="top">
                    <span class="status">{{item.status}}</span>
                    <span class="time">{{item.time}}</span>
                  </div>
                  <div class="content">
                    <span>{{item.context}}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
          <div v-if="content && content.onetoone_obj && content.onetoone_obj.reserve_senior_id !== null">
            <div class="dialog-item"
                 v-if="title=='对接辅导'||title=='确认完成'">
              <div class="title">
                <div class="blue"></div>
                <span>预约学长</span>
              </div>

              <div class="goodsMess"
                   style="marginTop:16px">
                <div class="messItem">
                  <!-- v-if="content.onetoone_obj||content.answer_card_obj" -->
                  <p class="itemLeft">ID</p>
                  <p class="itemRight"
                     v-if="content.onetoone_obj">{{content.onetoone_obj.reserve_senior_obj.senior_id}}</p>
                  <p class="itemRight"
                     v-if="content.answer_card_obj">{{content.answer_card_obj.answer_senior_obj.senior_id}}</p>
                </div>
              </div>
              <div class="goodsMess">
                <div class="messItem">
                  <p class="itemLeft">昵称</p>
                  <p class="itemRight"
                     v-if="content.onetoone_obj">{{content.onetoone_obj.reserve_senior_obj.senior_nickname}}</p>
                  <p class="itemRight"
                     v-if="content.answer_card_obj">{{content.answer_card_obj.answer_senior_obj.senior_nickname}}</p>
                </div>
              </div>
              <div class="goodsMess">
                <div class="messItem">
                  <p class="itemLeft">姓名</p>
                  <p class="itemRight"
                     v-if="content.onetoone_obj">{{content.onetoone_obj.reserve_senior_obj.senior_realname}}</p>
                  <p class="itemRight"
                     v-if="content.answer_card_obj">{{content.answer_card_obj.answer_senior_obj.senior_realname}}</p>
                </div>
              </div>
              <div class="goodsMess">
                <div class="messItem">
                  <p class="itemLeft">性别</p>
                  <p class="itemRight"
                     v-if="content.onetoone_obj">{{content.onetoone_obj.reserve_senior_obj.senior_gender==1 ?'男':'女'}}</p>
                  <p class="itemRight"
                     v-if="content.answer_card_obj">{{content.answer_card_obj.answer_senior_obj.senior_gender==1?'男':'女'}}</p>
                </div>
              </div>
              <div class="goodsMess">
                <div class="messItem">
                  <p class="itemLeft">录取信息</p>
                  <p class="itemRight"
                     v-if="content.onetoone_obj">
                    {{content.onetoone_obj.reserve_senior_obj.senior_recruit_year}}/{{content.onetoone_obj.reserve_senior_obj.senior_college_name}}/{{content.onetoone_obj.reserve_senior_obj.senior_major_name}}
                  </p>

                  <p class="itemRight"
                     v-if="content.answer_card_obj">
                    {{content.answer_card_obj.answer_senior_obj.senior_recruit_year}}/{{content.answer_card_obj.answer_senior_obj.senior_college_name}}/{{content.answer_card_obj.answer_senior_obj.senior_major_name}}
                  </p>
                </div>
              </div>
              <div class="goodsMess">
                <div class="messItem">
                  <p class="itemLeft">初试总分</p>
                  <p class="itemRight">{{score}}分</p>
                </div>
              </div>
              <div class="goodsMess"
                   style=" border-bottom: 1px solid rgb(215, 213, 213)">
                <div class="messItem">
                  <p class="itemLeft">手机号</p>
                  <p class="itemRight"
                     v-if="content.onetoone_obj">{{content.onetoone_obj.reserve_senior_obj.senior_mobile}}</p>

                  <p class="itemRight"
                     v-if="content.answer_card_obj">{{content.answer_card_obj.answer_senior_obj.senior_mobile}}</p>

                </div>
              </div>
            </div>
          </div>

          <div class="dialog-item"
               v-if="title=='对接辅导'||title=='确认完成'||title=='退款'"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>备注信息</span>
            </div>

            <el-form ref="searchForm"
                     style="marginTop:20px"
                     v-if="title=='对接辅导'||title=='确认完成'||title=='退款'"
                     :inline="true"
                     :model="form"
                     label-width="70px">
              <el-form-item label="用户备注"
                            prop="order_no">
                <el-input @input="Update('buyer_remark')"
                          type="textarea"
                          :rows="2"
                          placeholder="请输入买家备注"
                          v-model="content.buyer_remark">
                </el-input>
              </el-form-item>
              <el-form-item label="商品备注"
                            prop="order_no">
                <el-input @input="Update('seller_remark')"
                          type="textarea"
                          :rows="2"
                          placeholder="请输入卖家备注"
                          v-model="content.seller_remark">
                </el-input>
              </el-form-item>

            </el-form>
          </div>
          <div class="dialog-item"
               v-if="title=='对接辅导'||title=='确认完成'||title=='查看详情'"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>对接进程</span>
            </div>

            <el-form ref="searchForm"
                     style="marginTop:20px"
                     v-if="title=='对接辅导'||title=='确认完成'||title=='查看详情'"
                     :inline="true"
                     :model="form"
                     label-width="70px">
              <el-form-item label="辅导状态"
                            prop="status">
                <el-select v-model="form.status"
                           placeholder="请选择"
                           clearable
                           @change="statusUpdate(1)"
                           style="width:200px;">
                  <el-option v-for="item in filter.status"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务备注"
                            v-if="content.onetoone_obj"
                            prop="order_no">
                <el-input @input="statusUpdate(2)"
                          type="textarea"
                          :rows="2"
                          placeholder="请输入服务备注"
                          v-model="content.onetoone_obj.course_before_remark">
                </el-input>
              </el-form-item>

            </el-form>
          </div>

          <!-- 收货地址 -->
          <div class="dialog-item"
               v-if="title=='立即发货'"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>收获地址</span>
            </div>

            <el-form ref="searchForm"
                     style="marginTop:20px"
                     v-if="title=='立即发货'"
                     :inline="true"
                     :model="form"
                     label-width="70px">

              <el-form-item label="收件姓名"
                            prop="order_no">
                <el-input v-model="content.receiver_name"
                          type="textarea"
                          @input="Update('receiver_name')"
                          placeholder="请输入收件人姓名"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>
              <el-form-item label="收件号码"
                            prop="order_no">
                <el-input v-model="content.receiver_mobile"
                          type="textarea"
                          @input="Update('receiver_mobile')"
                          placeholder="请输入收件人号码"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>
              <el-form-item label="收件邮箱"
                            prop="order_no">
                <el-input v-model="content.receiver_email"
                          type="textarea"
                          @input="Update('receiver_email')"
                          placeholder="请输入收件邮箱"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>
              <el-form-item label="收件人地址"
                            prop="order_no">
                <el-input v-model="content.receiver_address"
                          type="textarea"
                          @input="Update('receiver_address')"
                          placeholder="请输入收件人地址"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>

            </el-form>
          </div>

          <div class="dialog-item"
               v-if="title=='立即发货'"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>备注信息</span>
            </div>

            <el-form ref="searchForm"
                     style="marginTop:20px"
                     v-if="title=='立即发货'"
                     :inline="true"
                     :model="form"
                     label-width="70px">

              <el-form-item label="用户备注"
                            prop="order_no">
                <el-input v-model="form.order_no"
                          type="textarea"
                          placeholder="请输入备注"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>
              <el-form-item label="商品备注"
                            prop="order_no">
                <el-input v-model="form.order_no"
                          type="textarea"
                          placeholder="请输入备注"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>
            </el-form>
          </div>

          <div class="dialog-item"
               v-if="title=='立即发货'"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>发货信息</span>
            </div>

            <el-form ref="searchForm"
                     style="marginTop:20px"
                     v-if="title=='立即发货'"
                     :inline="true"
                     :model="form"
                     label-width="70px">
              <el-form-item label="选择快递"
                            prop="express_code">

                <el-select v-model="content.express_code"
                           placeholder="请选择快递公司"
                           style="width: 100%;">
                  <el-option v-for="item in expressList"
                             :key="item.code"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>

              </el-form-item>
              <el-form-item label="快递单号"
                            prop="order_no">
                <el-input v-model="content.express_no"
                          placeholder="请输入快递单号"
                          clearable
                          style="width:200px;"></el-input>
              </el-form-item>

              <div style="marginTop:10px">物流信息 ：<span v-if="expressInfo==null">暂无数据</span></div>

              <div class="value">
                <div class="info-list"
                     v-if="expressInfo">
                  <div class="info-item"
                       v-for="(item, index) of expressInfo.list"
                       :key="index">
                    <div class="top">
                      <span class="status">{{item.status}}</span>
                      <span class="time">{{item.time}}</span>
                    </div>
                    <div class="content">
                      <span>{{item.context}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <el-form-item label="服务备注"
                            prop="order_no"
                            v-if="content.onetoone_obj">
                <el-input @input="statusUpdate(2)"
                          type="textarea"
                          :rows="2"
                          placeholder="请输入服务备注"
                          v-model="content.onetoone_obj.course_before_remark">
                </el-input>
              </el-form-item>
            </el-form>
          </div>

          <div class="dialog-item"
               v-if="title=='退款'"
               style="marginTop:20px">
            <div class="title">
              <div class="blue"></div>
              <span>退款操作</span>
            </div>

            <el-form ref="searchForm"
                     style="marginTop:20px"
                     v-if="title=='退款'"
                     :inline="true"
                     :model="form"
                     label-width="70px">
              <el-form-item label="是否退款">
                <el-radio-group v-model="form.refundStatus">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="退款金额">
                <el-input v-model="content.refund_amount"
                          placeholder="请输入退款金额"
                          clearable
                          style="width:200px;"></el-input><span style="marginLeft:10px">元</span>
              </el-form-item>

              <div style="marginBottom:20px">发起申请退款金额：{{ content.apply_refund_fee || "0" }}元</div>
              <div style="marginBottom:20px">成功退款到账金额{{ content.refund_fee || "0" }}元</div>

              <el-form-item label="服务备注"
                            v-if="content.onetoone_obj"
                            prop="order_no">
                <el-input @input="statusUpdate(2)"
                          type="textarea"
                          :rows="2"
                          placeholder="请输入服务备注"
                          v-model="content.onetoone_obj.course_before_remark">
                </el-input>
              </el-form-item>

            </el-form>
          </div>
          <div class="footer">
            <!-- <div class="cancle"
                 @click="handleClose()">取消</div> -->
            <div class="confirm"
                 @click="refund()"
                 v-if="title=='退款'">退款</div>

            <div class="confirm"
                 @click="handleSubmit()"
                 v-if="title=='立即发货'">确定</div>

          </div>

        </div>
      </div>

      <!-- <div class="order-wrap">
        <div class="card-wrap">
          <div class="inner">
            <div class="title">基础信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">订单状态：</div>
                <div class="value">
                  <el-select v-model="content.status"
                             placeholder="请选择"
                             @change="changeStatus">
                    <el-option label="待支付"
                               :value="0"> </el-option>
                    <el-option label="已支付"
                               :value="1"> </el-option>
                    <el-option label="待发货"
                               :value="2"> </el-option>
                    <el-option label="待收货"
                               :value="3"> </el-option>
                    <el-option label="已完成"
                               :value="4"> </el-option>
                    <el-option label="已取消"
                               :value="5"> </el-option>
                  </el-select>
                </div>
              </div>
              <div class="info-row">
                <div class="label">创建时间：</div>
                <div class="value">
                  {{
                    $moment(content.create_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    ) || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">系统订单号：</div>
                <div class="value">{{ content.order_no || "--" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap"
             v-if="activityInfo">
          <div class="inner"
               v-if="activityInfo.activity_group">
            <div class="title">拼团信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">拼团ID：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.id }}
                </div>
                <div v-else> -</div>
              </div>
              <div class="info-row">
                <div class="label">拼团状态：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    formateActivityStatus(activityInfo.activity_group.status)
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">拼团人数：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.user_count }}人团
                </div>
              </div>
              <div class="info-row">
                <div class="label">已拼人数：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.done_user_count }}人
                </div>
              </div>
              <div class="info-row">
                <div class="label">发起时间：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    $moment(activityInfo.activity_group.create_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">更新时间：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    $moment(activityInfo.activity_group.update_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">商品信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">商品封面：</div>
                <div class="value">
                  <div v-if="content.ref_type == 7">
                    <img v-for="(item, index) in content.multi_ref_list"
                         :key="index"
                         :src="item.goods_img"
                         alt=""
                         style="margin: 0px 6px" />
                  </div>
                  <img :src="content.goods_img"
                       alt="" />
                </div>
              </div>
              <div class="info-row">
                <div class="label">商品类型：</div>
                <div class="value">
                  {{
                    {
                      "0": "无",
                      "1": "课程",
                      "2": "题库",
                      "3": "专栏",
                      "4": "资料",
                      "5": "文章",
                      "6": "学长",
                      "7": "联报",
                    }[content.ref_type] || "--"
                  }}
                </div>
              </div>
              <div class="info-row"
                   style="align-items: start">
                <div class="label">商品名称：</div>
                <div class="goods-name-value"
                     v-if="content.ref_type == 7">
                  <span class="goods-name-span"
                        v-for="(item, index) in content.multi_ref_list"
                        :key="index">{{ item.goods_name }}</span>
                </div>
                <span v-else>{{ content.goods_name }}</span>
              </div>
              <div class="info-row"
                   v-if="properties.length > 0">
                <div class="label">商品规格：</div>
                <div v-for="(item,i) in properties"
                     :key="i">
                  <span class="properties-style"> {{item.key}}：{{item.val}}
                    <template v-if="i < properties.length - 1">,</template>
                    <template v-else>;</template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">支付信息</div>
            <div class="info-wrap">
              <! 联报，多个商品原价  start-->
      <!-- <div class="info-row"
           v-if="content.ref_type == 7">
        <div class="label">商品价格：</div>
        <div class="value">{{ formateMulti_ref_listPrice() }}</div>
      </div> -->
      <!--  联报，多个商品原价  end-->

      <!--  联报，多个商品联报价  start-->
      <!-- <div class="info-row"
           v-if="content.ref_type == 7">
        <div class="label">联报优惠：</div>
        <div class="value">{{ formateMulti_ref_listJointPrice() }}</div>
      </div> -->
      <!--  联报，多个商品联报价   end-->

      <!-- <div class="info-row"
           v-else>
        <div class="label">商品价格：</div>
        <div class="value">{{ content.price || "0" }}元</div>
      </div>
      <div class="info-row"
           v-if="content.earnest_order_id && content.earnest_order_amount">
        <div class="label">定金抵扣：</div>
        <div class="value">{{ content.earnest_order_amount }}元</div>
      </div>
      <div class="info-row">
        <div class="label">优惠券金额：</div>
        <div class="value">
          {{ content.user_coupon_amount || "0" }}元
        </div>
      </div>
      <div class="info-row">
        <div class="label">订单总金额：</div>
        <div class="value">{{ content.total_amount || "0" }}元</div>
      </div>
      <div class="info-row">
        <div class="label">支付金额：</div>
        <div class="value">{{ content.pay_amount || "0" }}元</div>
      </div>

      <div class="info-row">
        <div class="label">支付方式：</div>
        <div class="value">
          {{
                    {
                      "0": "--",
                      "1": "支付宝",
                      "2": "微信",
                      "3": "系统",
                      "4": "花呗分期",
                      "5": "研币",
                    }[content.pay_type] || "--"
                  }}
        </div>
      </div>
      <div class="info-row">
        <div class="label">支付状态：</div>
        <div class="value">
          {{
                    { "0": "未支付", "1": "已支付", "2": "已取消" }[
                      content.pay_status
                    ] || "--"
                  }}
        </div>
      </div> -->
      <!-- <div class="info-row">
        <div class="label">支付时间：</div>
        <div class="value">
          {{
                    content.pay_time
                      ? $moment(content.pay_time).format("YYYY.MM.DD HH:mm:ss")
                      : "--"
                  }}
        </div>
      </div>
      <div class="info-row">
        <div class="label">商户交易号：</div>
        <div class="value">{{ content.out_trade_no || "--" }}</div>
      </div>
      <div class="info-row">
        <div class="label">支付订单号：</div>
        <div class="value">{{ content.pay_trade_no || "--" }}</div>
      </div>
  </div>
  </div>
  </div> -->
      <!-- <div class="card-wrap"
       v-if="isRefund">
    <div class="inner"
         style="min-height: 0px">
      <div class="title">退款</div>
      <el-form ref="form"
               label-width="85px"
               style="margin-top: 16px"
               :inline="true">
        <el-form-item label="退款金额">
          <el-input v-model="content.refund_amount"
                    style="width: 150px"></el-input>
          元
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary"
                     @click="profitSharing"
                     :disabled="unsplit_amount == 0">分账完结</el-button>
          <el-button type="primary"
                     @click="refund">退款</el-button>
        </el-form-item>
      </el-form>
      <div class="info-row"
           style="margin-left: 16px">
        <div class="label">发起申请退款金额：</div>
        <div class="value">{{ content.apply_refund_fee || "0" }}元</div>
      </div>
      <div class="info-row"
           style="margin-top: 16px; margin-left: 16px">
        <div class="label">成功退款到账金额：</div>
        <div class="value">{{ content.refund_fee || "0" }}元</div>
      </div>
    </div>
  </div>
  <div class="card-wrap">
    <div class="inner">
      <div class="title">用户信息</div>
      <div class="info-wrap">
        <div class="info-row">
          <div class="label">ID：</div>
          <div class="value">{{ user.id || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">姓名：</div>
          <div class="value">{{ user.realname || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">昵称：</div>
          <div class="value">{{ user.nickname || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">手机号：</div>
          <div class="value">{{ user.mobile || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">邮箱：</div>
          <div class="value">{{ user.email || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">性别：</div>
          <div class="value">
            {{ user.gender ? (user.gender == 1 ? "男" : "女") : "--" }}
          </div>
        </div>
        <div class="info-row">
          <div class="label">角色：</div>
          <div class="value">
            {{ user.role ? (user.role == 1 ? "学生" : "学长") : "--" }}
          </div>
        </div>
        <div class="info-row">
          <div class="label">当前所在地：</div>
          <div class="value">
            {{ user.location ? user.location.area || "--" : "--" }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-wrap">
    <div class="inner">
      <div class="title">收件信息</div>
      <div class="info-wrap">
        <div class="info-row">
          <div class="label">收件人姓名：</div>
          <div class="value">{{ content.receiver_name || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">收件人手机号：</div>
          <div class="value">{{ content.receiver_mobile || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">收件人邮箱：</div>
          <div class="value">{{ content.receiver_email || "--" }}</div>
        </div>
        <div class="info-row">
          <div class="label">收件人地址：</div>
          <div class="value">{{ content.receiver_address || "--" }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-wrap">
    <div class="inner">
      <div class="title">其他信息</div>
      <div class="info-wrap">
        <div class="info-row">

          <div class="label">买家备注：</div>
          <div class="value">
            <el-input @input="Update('buyer_remark')"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入买家备注"
                      v-model="content.buyer_remark">
            </el-input>

          </div>
        </div>
        <div class="info-row">
          <div class="label">卖家备注：</div>
          <div class="value">

            <el-input @input="Update('seller_remark')"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入卖家备注"
                      v-model="content.seller_remark">
            </el-input>

          </div>
        </div>
        <div class="info-row">
          <div class="label">系统备注：</div>
          <div class="value">
            <el-input @input="Update('system_remark')"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入系统备注"
                      v-model="content.system_remark">
            </el-input>

          </div>
        </div>
      </div>
    </div>
  </div>
  </div> -->
    </el-dialog>
  </div>
</template>


<script>
import {
  orderrefund,
  memberOrderUpdate,
  memberOrderOne,
  oneToOneInfoPut,
  profitSharingFinish,
  profitSharingAmountQuery,
  answerCardInfo,
} from '@/api/member.js'
import { seniorOne, seniorUpdateStatus, seniorUpdate } from '@/api/senior'
import { memberOrderExpress, memberOrderShipping } from '@/api/member'
import { computePermission } from '@/utils/helper.js'
import { memberActivityOrderOne } from '@/api/operation.js'
import { expressList } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    userStatus: {
      type: Number,
      default: () => {
        return null
      },
    },
    titles: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      expressInfo: null,
      title: '', // 商品规格
      properties: [],
      dialogVisible: this.visible,
      user: this.userContent || {},
      isRefund: false,
      activityInfo: null,
      dialogWidth: '800px',
      content: {},
      unsplit_amount: 0,
      form: { status: '0', refundStatus: 1 },
      filter: {
        status: [
          {
            label: '待辅导',
            value: '6',
          },
          {
            label: '辅导中',
            value: '7',
          },
          {
            label: '已完成',
            value: '4',
          },
        ],
      },
      type: 0,
      expressList: [],
      score: null,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchOrderdetail()
        /*     if (this.content.activity_id) {
              this.fetActivityInfo()
            } */
      }
    },

    titles(val) {
      console.log('val55', val)
      if (val) {
        this.type = '退款'
      } else {
        this.type = ''
      }
    },
    userStatus(val) {
      console.log('valf', val)
      if (val == 2) {
        this.title = '立即发货'
      } else if (val == 6) {
        this.title = '对接辅导'
      } else if (val == 7) {
        this.title = '确认完成'
      } else if (val == 9) {
        this.title = '确认完成'
      } else {
        if (this.type == '退款') {
          this.title = '退款'
        } else {
          this.title = '查看详情'
        }
      }
    },
  },
  created() {
    this.isRefund = computePermission('refund:order')
  },
  methods: {
    handleSubmit() {
      let params = {}
      // const params = Object.assign({}, this.dataForm, {
      //   id: this.content.id,
      // })
      if (this.content.express_code == '') {
        params.id = this.content.id
        params.express_code = ''
        params.express_no = ''
      } else {
        params.id = this.content.id
        params.express_code = this.content.express_code
        params.express_no = this.content.express_no
      }
      memberOrderShipping(params)
        .then((res) => {
          this.$message.success(`更新成功`)

          // this.editStatus = false
          this.$emit('submit')
          // 刷新物流信息
          this.fetchExpressInfo()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    fetchOrderdetail() {
      console.log('this.id', this.id)
      const query = {
        id: this.id,
        is_get_note_info: 1,
      }
      memberOrderOne(query).then((res) => {
        if (res) {
          this.content = res
          this.form.status = this.content.status + ''
          this.fetchExpressList()
          if (this.content.express_code && this.content.express_no) {
            this.fetchExpressInfo()
          }
          if (res.sku) {
            this.properties = res.sku.properties
          }

          if (res.activity_id) {
            this.fetActivityInfo()
          }
          if (res.pay_type == 2) {
            this.queryWechatProfitSharing()
          }
          // if (this.title == '对接辅导' || this.title == '确认完成') {
          //   if (res.answer_card_obj) {
          //     this.getSenior(res.answer_card_obj.answer_senior_obj.senior_uid)
          //   } else if (res.onetoone_obj) {
          //     this.getSenior(res.onetoone_obj.reserve_senior_obj.senior_uid)
          //   }
          // }
          if (res.answer_card_obj) {
            this.filter.status = [
              {
                label: '答疑中',
                value: '9',
              },
              {
                label: '已完成',
                value: '4',
              },
            ]
          } else {
            this.filter.status = [
              {
                label: '待辅导',
                value: '6',
              },
              {
                label: '辅导中',
                value: '7',
              },
              {
                label: '已完成',
                value: '4',
              },
            ]
          }
        }
      })
    },
    // 快递列表查询
    fetchExpressList() {
      expressList({ pageSize: 20 }).then((res) => {
        if (res) {
          let list = res.list
          list.unshift({ code: '', name: '无需物流' })
          this.expressList = list
        }
      })
    },
    // 快递进度查询
    fetchExpressInfo() {
      memberOrderExpress({ order_id: this.content.id }).then((res) => {
        if (res) {
          this.expressInfo = res
        }
      })
    },
    // 学长详情
    getSenior(id) {
      seniorOne({ uid: id }).then((res) => {
        this.score = res.score
        console.log('resll', res)
      })
    },

    fetActivityInfo() {
      const query = {
        id: this.content.id,
        uid: this.content.uid,
      }
      memberActivityOrderOne(query).then((res) => {
        if (res) {
          this.activityInfo = res
        }
      })
    },
    queryWechatProfitSharing() {
      const query = {
        transaction_id: this.content.pay_trade_no,
      }
      profitSharingAmountQuery(query).then((res) => {
        if (res) {
          this.unsplit_amount = parseInt(res.data.unsplit_amount)
        }
      })
    },
    handleClose() {
      // this.type = ''
      this.properties = []
      this.activityInfo = null
      this.$emit('close')
    },
    handleOpen() {},
    // 订单状态渲染
    statusRender() {
      const pay_status = {
        0: '未支付',
        1: '已支付',
        2: '已取消',
      }
      const audit_status = {
        0: '待审核',
        1: '审核通过',
        2: '审核未通过',
      }
      const refund_status = {
        0: '未申请',
        1: '退款中',
        2: '已退款',
      }
      return pay_status[this.content.pay_status] || '--'
    },
    statusUpdate(type) {
      console.log('this.fomr', this.form)
      let query = {
        order_id: this.content.id,
      }
      if (type == 1) {
        if (this.form.status == '7') {
          query.onetoone_status = 1
        } else if (this.form.status == '4') {
          if (this.content.answer_card_obj) {
            query.answer_card_status = 1
          } else {
            query.onetoone_status = 2
            query.tutor_senior_id = this.content.onetoone_obj.reserve_senior_id
          }
        }
      } else if (type == 2) {
        query.course_before_remark =
          this.content.onetoone_obj.course_before_remark
      }
      if (this.content.answer_card_obj) {
        answerCardInfo(query).then((res) => {})
      } else {
        oneToOneInfoPut(query).then((res) => {})
      }
    },
    Update(name) {
      let data = {
        id: this.content.id,
      }
      data[name] = this.content[name]
      memberOrderUpdate(data).then((res) => {})
    },
    formatJointProduct(row) {
      if (row.multi_ref_list.length) {
        let str = row.multi_ref_list
          .map((v) => {
            return v.goods_name
          })
          .join(',')
        return str
      } else {
        return '无'
      }
    },
    refund() {
      if (this.form.refundStatus == 1) {
        if (!this.content.refund_amount) {
          this.$message.error(`请填写退款金额`)
          return
        }
        if (!/^(\d+|\d+\.\d{1,2})$/.test(this.content.refund_amount)) {
          this.$message.error(`请填写正确的退款金额`)
          return
        }
        const query = {
          id: this.content.id,
          refund_amount: this.content.refund_amount,
        }
        orderrefund(query)
          .then((res) => {
            if (res != '申请退款金额溢出') {
              this.$message.success(`退款成功`)
              this.content.refund_amount = 0
              this.handleClose()
            }
          })
          .catch((error) => {
            console.log('error: ', error)
          })
      }
    },
    formateActivityStatus(status) {
      const obj = ['正在拼团', '拼团成功', '拼团失败']
      return obj[status]
    },
    formateMulti_ref_listPrice() {
      let arr = this.content.multi_ref_list.map((v) => {
        if (v.price) {
          return v.price.toFixed(2) + '元'
        } else {
          return '未知'
        }
      })
      return arr.join('/')
    },
    formateMulti_ref_listJointPrice() {
      let arr = this.content.multi_ref_list.map((v) => {
        if (v.price) {
          return (v.price - v.joint_price).toFixed(2) + '元'
        } else {
          return '未知'
        }
      })
      return arr.join('/')
    },
    profitSharing() {
      let out_order_no =
        this.content.profit_share_order &&
        this.content.profit_share_order.details
          ? this.content.profit_share_order.details.find((v) => {
              return v.description == '分到个人'
            }).detail_id
          : null
      console.log(out_order_no)
      const data = {
        out_order_no: out_order_no,
        transaction_id: this.content.pay_trade_no,
      }
      profitSharingFinish(data)
        .then((res) => {
          if (res.data.success) {
            this.$message.success(`操作成功`)
            this.fetchOrderdetail()
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.dialog-wrap {
  .footer {
    margin-top: 20px;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    .cancle {
      text-align: center;
      font-size: 14px;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      margin-right: 10px;
    }
    .confirm {
      text-align: center;
      width: 56px;
      height: 36px;
      font-size: 14px;
      line-height: 36px;
      color: #fff;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
  .dialog-item {
    .title {
      width: 100px;
      font-weight: 600;
      font-size: 14px;
      display: flex;

      .blue {
        margin-right: 6px;
        width: 4px;
        height: 16px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .goodsMess {
      font-size: 12px;
      width: 350px;
      border: 1px solid rgb(215, 213, 213);
      border-bottom: none;
      .messItem {
        display: flex;
        align-items: center;
        font-size: 12px;
        width: 100%;
        min-height: 34px;
        border-bottom: none;
        .itemLeft {
          font-size: 12px;
          padding-left: 8px;
          line-height: 34px;
          width: 100px;
          min-height: 34px;
          background: #dcdfe6;
        }
        .itemRight {
          padding-left: 10px;
          width: 320px;
        }
      }
    }
  }
}

// .dialog-wrap {
//   .order-wrap {
//     display: flex;
//     flex-direction: column;
//     .wrap-item {
//       margin: 20px 40px 0 40px;
//       display: flex;
//       flex-direction: row;
//       justify-content: space-between;
//     }
//   }
//   .card-wrap {
//     width: 100%;
//     padding: 5px;

//     .inner {
//       min-height: 100px;
//       border: 1px dashed #ccc;
//       border-radius: 6px;
//       padding: 5px 5px 10px;
//     }
//     .title {
//       font-size: 14px;
//       font-weight: bold;
//     }
//     .info-wrap {
//       margin-top: 15px;
//     }
//     .info-row {
//       display: flex;
//       align-items: center;
//       font-size: 13px;

//       & + .info-row {
//         margin-top: 10px;
//       }

//       .label {
//         width: 120px;
//         text-align: right;
//         color: #666;
//       }
//       .goods-name-value {
//         margin-left: 10px;
//         .goods-name-span {
//           display: block;
//           margin-bottom: 5px;
//         }
//       }
//       .value {
//         flex: 1;
//         color: #333;
//         margin-left: 10px;
//       }
//       .properties-style {
//         display: inline-block;
//         width: 80px;
//       }
//       img {
//         max-width: 80px;
//       }
//     }
//   }

//   /deep/ .el-dialog__body {
//     padding-top: 10px;
//   }
//   .result {
//     margin-top: 10px;
//   }
//   .footer {
//     margin-top: 10px;
//   }
// }
</style>
